export default __webpack_public_path__ + "locales/tr/Webhooks.json?hash=b455ba35319d699a1ef709c7e246e132";